<template>
  <div id="page-newsArticle-list-list">
    <vx-title-bar :route="$route" :isRTL="$vs.rtl" />
    <div class="vx-card p-6">
      <div class="mb-6">
        <vs-button @click="add" color="primary" type="border" icon="add"
          >{{$t('NewsArticleList.New')}}</vs-button
        >
      </div>
      <div class="flex flex-wrap items-center">
        <dx-data-grid
          class="dx-card wide-card"
          :data-source="customDataSource"
          :focused-row-index="0"
          :show-borders="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          @row-click="gotoDetails"
          :ref="gridRefKey"
        >
          >
          <dx-state-storing
            :enabled="true"
            type="custom"
            :custom-load="loadState"
            :custom-save="saveState"
            :storage-key="storageKey"
          />
          <dx-paging :page-size="20" />
          <dx-pager :show-page-size-selector="false" :show-info="true" />
          <dx-filter-row :visible="true" />

          <dx-column
            data-field="id"
            caption="Id"
            data-type="number"
            :width="90"
            :hiding-priority="2"
          />

          <dx-column
            data-field="name"
            :caption="$t('NewsArticleList.Name')"
            :width="190"
            :hiding-priority="8"
          />
        </dx-data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moduleNewsArticleListManagement from '@/store/news-article-list-management/moduleNewsArticleListManagement.js'
import CustomStore from 'devextreme/data/custom_store'
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxPaging,
  DxStateStoring
} from 'devextreme-vue/data-grid'

const gridRefKey = "grid-newsArticlelists"
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxPaging,
    DxStateStoring
  },
  data () {
    const customDataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.$store.dispatch('newsArticleListManagement/fetchNewsArticleLists', this.activeOrganisation.id)
          .then((res) => {
            return res.data.items
          })
          .catch((err) => {
            console.error(err)
          })
      }
    })

    return {
      customDataSource,
      gridRefKey,
      storageKey: 'dx_datagrid_gridNewsArticleList_1',
      restoreFullGridState: false
    }
  },
  watch: {
    activeOrganisation: function (val) {
      console.log(`activeOrganisation changed to ${val.id}`)
      this.refreshGrid()
    },

  },
  computed: {
    ...mapGetters(["activeOrganisation"])
  },
  methods: {
    gotoDetails (e) {
      if (e.rowType === 'data') {
        const grid = this.$refs[gridRefKey].instance
        grid.selectRows([e.key], false)
        localStorage[this.storageKey] = JSON.stringify(grid.state())
        this.$router.push(`/newsArticlelist/edit/${e.key}`).catch(() => { })
      }
    },
    add () {
      this.$router.push("/newsArticlelist/new")
    },
    loadState () {
      const storage = localStorage[this.storageKey]
      if (storage) {
        const state = JSON.parse(storage)

        if (this.restoreFullGridState) {
          return state
        } else {
          const res = {
            columns: state.columns,
            pageSize: state.pageSize
          }
          for (let i = 0; i < res.columns.length; i++) {
            delete res.columns[i].filterValue
          }
          return res
        }
      }
    },
    saveState (state) {
      localStorage[this.storageKey] = JSON.stringify(state)
    },
    refreshGrid () {
      const grid = this.$refs[gridRefKey].instance
      grid.refresh()
    },
  },
  mounted () {
  },
  created () {
    this.restoreFullGridState = this.$route.query.initial !== "true"
    if (!moduleNewsArticleListManagement.isRegistered) {
      this.$store.registerModule(
        'newsArticleListManagement',
        moduleNewsArticleListManagement
      )
      moduleNewsArticleListManagement.isRegistered = true
    }

  }
}
</script>

<style lang="scss">
#page-newsArticle-list-list {
  .newsArticle-list-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>